import { AddCommissionRequest, UpdateCommissionDateRequest } from "../redux/slice/saleDetails/SaleDetailsSlice";
import { http } from "./http";
import { ADD_COMMISSION_URL, GET_SALES_DETAILS_BY_ID, GET_SALES_DETAILS_BY_INVOICE_ID_URL, UPDATE_COMMISSION_DATE_URL } from "./URL";

export const getSaleDetailsById = async (orderId: number) => {
    try {
        const response = await http.get(`${GET_SALES_DETAILS_BY_ID}/${orderId}`);
        return response
    } catch (error) {
        throw error;
    }
}

export const getSaleDetailsByInvoice = async (invoiceId: number) => {
    try {
        const response = await http.get(`${GET_SALES_DETAILS_BY_INVOICE_ID_URL}/${invoiceId}`);
        return response
    } catch (error) {
        throw error;
    }
}

export const addCommissionAmount = async (data: AddCommissionRequest, skipLoader: boolean = false) => {
    try {
        const response = skipLoader
            ? await http.post(ADD_COMMISSION_URL, data, { headers: { "x-skip-loader": "true" } })
            : await http.post(ADD_COMMISSION_URL, data);
        return response
    } catch (error) {
        throw error;
    }
}

export const updateCommissionDate = async (data: UpdateCommissionDateRequest) => {
    try {
        const response = await http.post(UPDATE_COMMISSION_DATE_URL, data);
        return response
    } catch (error) {
        throw error;
    }
}